import { CurrentFlow } from "../context/urlContext";

export const DEFAULT_FEATURE_KEY = "ab-test-default-feature-flag";

export const FEATURE_KEY_BY_FLOW: Partial<Record<Exclude<CurrentFlow, null>, string>> = {
  "new-h": "ab-test-default-feature-flag",
  "new-h2": "ab-test-default-feature-flag",
  "new-s": "ab-test-default-feature-flag-new-s",
  "iq-test": "abc-test-default-feature-flag",
  "w2a-reading": "ab-test-default-feature-flag",
  "w2a-lessons": "ab-test-default-feature-flag",
  "w2a-mind-palace": "ab-test-default-feature-flag",
};

export const DEFAULT_MIN_VARIANT = 1;
export const DEFAULT_MAX_VARIANT = 2;

export const MAX_VARIANT_BY_FLOW: Partial<Record<Exclude<CurrentFlow, null>, number>> = {
  "new-h": 2,
  "new-h2": 2,
  "new-s": 2,
  "iq-test": 3,
  "w2a-reading": 2,
  "w2a-lessons": 2,
  "w2a-mind-palace": 2,
};
